import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { createAmountInputCodec } from './amount-input.js';
/** Keep incomplete input locally; changing the payment identity discards it before rendering. */
export function useFundingAmountDraft(t0) {
  const $ = _c(17);
  const {
    method,
    currency,
    decimals,
    locale,
    amountUnits
  } = t0;
  let t1;
  if ($[0] !== currency || $[1] !== decimals || $[2] !== locale || $[3] !== method) {
    t1 = JSON.stringify([method, currency, decimals, locale]);
    $[0] = currency;
    $[1] = decimals;
    $[2] = locale;
    $[3] = method;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const identity = t1;
  let t2;
  if ($[5] !== identity) {
    t2 = {
      identity,
      value: null
    };
    $[5] = identity;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [draft, setDraft] = useState(t2);
  if (draft.identity !== identity) {
    setDraft({
      identity,
      value: null
    });
  }
  const value = draft.identity === identity ? draft.value : null;
  let t3;
  if ($[7] !== amountUnits || $[8] !== decimals || $[9] !== locale || $[10] !== value) {
    t3 = value ?? (amountUnits ? createAmountInputCodec(locale, decimals).format(BigInt(amountUnits)) : "");
    $[7] = amountUnits;
    $[8] = decimals;
    $[9] = locale;
    $[10] = value;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== identity) {
    t4 = value_0 => setDraft({
      identity,
      value: value_0
    });
    $[12] = identity;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = {
      value: t3,
      setValue: t4
    };
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}